import React from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import DynamicBreadcrumbs from "../../../../../elements/v2/DynamicBreadcrumbs/DynamicBreadcrumbs";
import { Typography } from "@ann/web-components";
import { BreadcrumbContainer, CustomBreadcrumbWrapper } from "./Breadcrumb.styled";

const Breadcrumb = ({ triggerName, hasUnsavedChanges, saveImmediately }) => {
  const { triggerId } = useParams();
  const { pathname, state } = useLocation();
  const navigate = useNavigate();

  const getDisplayName = () => {
    return triggerName || 
           state?.triggerName || 
           localStorage.getItem('currentTriggerName') || 
           triggerId;
  };

  const handleNavigate = (href) => {
    // Save changes before navigating
    if (hasUnsavedChanges && saveImmediately) {
      saveImmediately();
    }
    navigate(href);
  };

  const items = [{ label: 'Workflows', href: '/v2/workflows' }];
  
  if (triggerId) {
    items.push({
      label: getDisplayName(),
      href: `/v2/workflows/${triggerId}`,
    });
  }

  return (
    <BreadcrumbContainer>
      <CustomBreadcrumbWrapper>
        <Typography category="body" size="small" weight="regular">
          Automations /
        </Typography>
        <DynamicBreadcrumbs 
          items={items} 
          currentPath={pathname}
          onNavigate={handleNavigate}
        />
      </CustomBreadcrumbWrapper>
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;
